import React, { useEffect } from 'react';
import { getImage } from './processImage';
import placeHolderImage from '../../assets/placeholder.png';

const BuzzImage = ({ src = '', placeHolder = placeHolderImage, ...rest }) => {
  // const image = '60b0b18514afaf5a71a1bac4220px-Article_15_Poster.jpg';
  const [img, setImg] = React.useState('');

  useEffect(async () => {
    if (
      src === undefined ||
      src === null ||
      src === '' ||
      src.slice(0, 7) === 'http://' ||
      src.slice(0, 8) === 'https://'
    ) {
      setImg(src);
    } else {
      try {
        if (src) {
          const imageUrl = await getImage(src);
          setImg(imageUrl);
        }
      } catch (error) {
        setImg(undefined);
      }
    }
  }, []);

  if (!src || !img) {
    return (
      <img
        src={placeHolder}
        alt="placeholder"
        {...rest}
        style={{ objectFit: 'cover' }}
      />
    );
  }

  return <img src={img} alt={'buzzImage'} {...rest} />;
};

export default BuzzImage;
